import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import { Marquee, Manifesto, Services, Gallery } from "@/components/site/Sections";
import { About, Contact, Footer } from "@/components/site/ContactFooter";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // anchor links -> lenis smooth scroll
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -10 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App grain bg-[#0b0b0a]" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Services />
          <Gallery />
          <About />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
